import { render, staticRenderFns } from "./order.vue?vue&type=template&id=849fd2ec&scoped=true&"
import script from "./orderDialog.js?vue&type=script&lang=js&"
export * from "./orderDialog.js?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&id=849fd2ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849fd2ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('849fd2ec')) {
      api.createRecord('849fd2ec', component.options)
    } else {
      api.reload('849fd2ec', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=849fd2ec&scoped=true&", function () {
      api.rerender('849fd2ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderDialog/order.vue"
export default component.exports